webpackJsonp([32],{

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LandersForeclosureModel; });
var LandersForeclosureModel = function LandersForeclosureModel(defaultParams, extraParams) {
  this.data = defaultParams;

  this.getData = function () {
    return this.data;
  };

  this.extraData = function () {
    return extraParams;
  };
};



/***/ }),

/***/ 129:
/***/ (function(module, exports) {

MOVE.HeroImages = function (MOVE) {
  "use strict";

  var init = function init(options) {
    var heroImages = $(options.target);
    // owl carousel
    heroImages.owlCarousel({
      lazyLoad: options.lazyLoad,
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 11000,
      animateOut: options.effect
    }); // /owlCarousel
  }; // /init closing brackets

  MOVE.HeroImages = {
    init: init
  };

  return MOVE.HeroImages;
}(MOVE || {});

/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_landers_foreclosure__ = __webpack_require__(1278);


(function (LANDERS_FORECLOSURE) {

  var init = function init() {
    LANDERS_FORECLOSURE.model = new __WEBPACK_IMPORTED_MODULE_0__models_landers_foreclosure__["a" /* LandersForeclosureModel */](defaultCriteriaOptions(), extraParameters());
  };

  var defaultCriteriaOptions = function defaultCriteriaOptions() {
    return {
      location: MOVE.SearchHelper.getRecentSearchedLocation(MOVE.CONSTANTS.DEFAULT_LANDING_PAGE_LOCATION),
      property_status: MOVE.CONSTANTS.PROPERTY_STATUS.forSale
    };
  };

  var extraParameters = function extraParameters() {
    return { medianPrice: getMedianPrice() };
  };

  var getMedianPrice = function getMedianPrice() {
    var $object = $("#foreclosure_landing");
    if ($object.data().medianprice !== undefined && $object.data().dspmedianprice !== undefined) {
      return {
        median_price: $object.data().medianprice,
        dsp_median_price: $object.data().dspmedianprice
      };
    } else {
      return {};
    }
  };

  LANDERS_FORECLOSURE.LandingPage = {
    init: init
  };
})(MOVE.LANDERS_FORECLOSURE);
MOVE.LANDERS_FORECLOSURE.LandingPage.init();

/***/ }),

/***/ 1447:
/***/ (function(module, exports) {

MOVE.LANDERS_FORECLOSURE = function (MOVE) {
  var init = function init() {};

  MOVE.LANDERS_FORECLOSURE = {
    init: init
  };

  return MOVE.LANDERS_FORECLOSURE;
}(MOVE || {});

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

MOVE.HOMEPAGE = function (MOVE) {
  var init = function init() {};

  MOVE.HOMEPAGE = {
    init: init
  };

  return MOVE.HOMEPAGE;
}(MOVE || {});

/***/ }),

/***/ 1643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_homepage_homepage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_homepage_homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_homepage_homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_landers_foreclosure_landers_foreclosure__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_landers_foreclosure_landers_foreclosure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_landers_foreclosure_landers_foreclosure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_landers_foreclosure_models_landers_foreclosure__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_landers_foreclosure_controllers_landers_foreclosure__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_app__);








/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ })

},[1643]);


// WEBPACK FOOTER //
// landers_foreclosure_critical-c1382c30e982b8ee56a3.js